"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _field = _interopRequireDefault(require("./field"));

var _styler = _interopRequireDefault(require("../../Styler/styler"));

var _stackedButtons = _interopRequireDefault(require("./subComponents/stackedButtons"));

var _textLabel = _interopRequireDefault(require("./subComponents/textLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldGroup = function FieldGroup(_ref) {
  var children = _ref.children,
      id = _ref.id,
      label = _ref.label,
      first = _ref.first,
      last = _ref.last,
      disabled = _ref.disabled,
      small = _ref.small,
      large = _ref.large;
  var fieldGroupStyles = ['co-form__field__group', {
    'co-form__field__group--first': first,
    'co-form__field__group--last': last
  }];
  return _react.default.createElement(_styler.default, {
    classNames: fieldGroupStyles
  }, function (styles) {
    return _react.default.createElement(_field.default, {
      id: id,
      label: label,
      disabled: disabled
    }, _react.default.createElement("div", {
      className: styles
    }, _react.default.Children.map(children, function (child) {
      return _react.default.cloneElement(child, {
        disabled: disabled,
        small: small,
        large: large
      });
    })));
  });
};

var exclusiveOrderProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('first', 'last'); // TODO: Validation needs to be supported

FieldGroup.propTypes = {
  children: _propTypes.node.isRequired,
  id: _propTypes.string,
  label: _propTypes.string,
  first: exclusiveOrderProps,
  last: exclusiveOrderProps,
  disabled: _propTypes.bool,
  small: _propTypes.bool,
  large: _propTypes.bool
};
FieldGroup.StackedButtons = _stackedButtons.default;
FieldGroup.TextLabel = _textLabel.default;
var _default = FieldGroup;
exports.default = _default;
FieldGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FieldGroup",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "first": {
      "type": {
        "name": "custom",
        "raw": "exclusiveOrderProps"
      },
      "required": false,
      "description": ""
    },
    "last": {
      "type": {
        "name": "custom",
        "raw": "exclusiveOrderProps"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};